
import React, { useState } from 'react';
import { 
  PricingHeader, 
  PricingToggle, 
  PricingCard, 
  TeamPricing,
  SecuritySection,
  PricingFooter
} from './pricing';

const Pricing = () => {
  const [billingPeriod, setBillingPeriod] = useState<'monthly' | 'yearly'>('yearly');

  const getPrice = (basePrice: number) => {
    if (billingPeriod === 'yearly') {
      return Math.round(basePrice * 0.8); // 20% discount
    }
    return basePrice;
  };

  const plans = [
    {
      name: "Startup",
      basePrice: 299,
      price: getPrice(299),
      period: billingPeriod === 'monthly' ? "per användare/månad" : "per användare/år",
      description: "Perfekt för mindre företag som deltar i upphandlingar regelbundet.",
      features: [
        "Upp till 5 upphandlingsanalyser/månad",
        "Grundläggande kravanalys",
        "Enkel jämförelse med historiska data",
        "30 dagars historik"
      ],
      isPopular: false,
      ctaText: "Börja gratis",
      showFreeTrial: true,
      badge: null
    },
    {
      name: "Business",
      basePrice: 449,
      price: getPrice(449),
      period: billingPeriod === 'monthly' ? "per användare/månad" : "per användare/år",
      description: "För växande företag med frekvent deltagande i upphandlingar.",
      features: [
        "Upp till 15 upphandlingsanalyser/månad",
        "Avancerad kravanalys",
        "Omfattande jämförelsedata",
        "Konkurrensanalys",
        "90 dagars historik",
        "Rekommendationer för anbudsoptimering"
      ],
      isPopular: true,
      ctaText: "Börja gratis",
      showFreeTrial: true,
      badge: "Populäraste valet"
    },
    {
      name: "Premium",
      basePrice: 899,
      price: getPrice(899),
      period: billingPeriod === 'monthly' ? "per användare/månad" : "per användare/år",
      description: "För företag med stort fokus på offentlig upphandling.",
      features: [
        "Obegränsade upphandlingsanalyser",
        "Djupgående strategisk analys",
        "Avancerad konkurrensanalys",
        "Prioriterad support",
        "12 månaders historik",
        "Personlig strategisk rådgivning",
        "API-integration",
        "Exportfunktioner för rapporter"
      ],
      isPopular: false,
      ctaText: "Börja gratis",
      showFreeTrial: true,
      badge: null
    }
  ];

  return (
    <section id="pricing" className="py-12 bg-gradient-to-b from-white to-yellow-300/10 connection-lines">
      <div className="container mx-auto px-4">
        <PricingHeader />
        
        <div className="flex justify-center items-center mb-8">
          <PricingToggle 
            billingPeriod={billingPeriod} 
            setBillingPeriod={setBillingPeriod} 
          />
        </div>

        <div className="text-center mb-8">
          <p className="text-darkgray/80 max-w-2xl mx-auto font-opensans">
            Flexibla abonnemang som du kan uppgradera eller nergradera när som helst efter behov. Ingen bindningstid vid månadsbetalning.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-12">
          {plans.map((plan, index) => (
            <PricingCard
              key={index}
              {...plan}
              billingPeriod={billingPeriod}
            />
          ))}
        </div>
        
        <TeamPricing />
        
        <PricingFooter />
        
        <SecuritySection />
      </div>
    </section>
  );
};

export default Pricing;
